import React from 'react';
import PrettyBox from "../PrettyBox/PrettyBox.tsx";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import {Link} from "react-router-dom";
import {Typography} from "@mui/material";
import p1 from "../../assets/icons/p1.png";
import QuranIcon from "../../assets/Quran.png";
import ZiaratIcon from "../../assets/icons2/bd4fd825-8a46-49d3-9f43-29b1c2efaf68.png";
import Mafatih from "../../assets/icons2/8c49b2cc-a811-4ed7-aa44-f4eb7b69ef3b.png";
import HadisBox from "../HadisBox/HadisBox.tsx";
import IranSanse from "../Typography/IranSanse.tsx";
import Loading from "../loading/Loading.tsx";
let News =
    [
        {
            "id": "1a15e2ce-00d7-4ebc-b426-c14882175792",
            "title": "قرآن",
            "link": "/Quran/",
            "icon": QuranIcon,
            "parentId": null,
            "order": "6",
            "isActive": true
        },
        {
            "id": "98cbfe71-6392-40a5-adf1-b26399c6a32b",
            "title": "زیارت نامه",
            "link": "/PilgrimageLetter",
            "icon": ZiaratIcon,
            "parentId": null,
            "order": "3",
            "isActive": true
        },
        {
            "id": "cd8ca639-55a3-4519-926a-aa61f572ad31",
            "title": "ادعیه و مناجات",
            "link": "/Mafatih/dua",
            "icon": Mafatih,
            "parentId": null,
            "order": "5",
            "isActive": true
         },
        // {
        //     "id": "1a15e2ce-00d7-4ebc-b426-c14882175792",
        //     "title": "اخبار بسیج",
        //     "link": "/News/BasijNews",
        //     "iconId": "f64ec396-3b7b-4086-bf9d-de918d799910",
        //     "parentId": null,
        //     "order": "6",
        //     "isActive": true
        // }
    ]
let current = localStorage.getItem('CurrentPrayerType')
export default function Prayers() {
    return (
        <div>
            <Loading></Loading>
            <PrettyBox Width={'100%'} Height={'120px'}>
                <Row className="g-0 pb-3 pt-4 mx-0 d-flex justify-content-center" style={{width: '100%'}}>
                    {
                        News.map(menu => {
                            return (
                                <Col key={menu.id}
                                     className="  text-center  mx-0 px-0">
                                    <Row className="g-0">
                                        <Link to={menu.link} className="mx-0 px-0">
                                            <Col className="d-flex justify-content-center">
                                                <div
                                                    className={'/News/' + current === menu.link ? "footerMenuBox3" : "footerMenuBox2"}>
                                                    <img src={menu.icon} alt=""/>
                                                </div>
                                            </Col>
                                        </Link>
                                    </Row>
                                    <Row className='footerText text-muted text-center g-0'>
                                        <Col className='text-center pt-2'>
                                            <Typography fontSize={12}
                                                        fontFamily={'iranSanse-medium'}>{menu.title}</Typography>
                                        </Col>
                                    </Row>
                                </Col>

                            )
                        })
                    }
                </Row>
            </PrettyBox>

            <Row className='g-0 px-2'>
                <Col>
                    <HadisBox x={1234}>
                        <IranSanse>
                            <h6>حضرت امام علی (ع) فرمود:</h6>
                            <span>خوشا به حال آنان که به بندگان خدا نیکی کند و برای آخرت خود زاد و توشه برگیرد.</span>
                            <span style={{alignSelf: 'end'}}>غررالحكم و دررالكلم ، ح ۵۹۵۵ </span>
                        </IranSanse>
                    </HadisBox>
                </Col>
            </Row>
        </div>
    )
}


